<template>
    <div style="background-color: #fff">
        <div class="views-footer-content">
            <div class="friend-link-shell">
                <div class="friend-link-title">
                    友情链接
                </div>
                <div class="friend-link-list">
                    <a class="friend-link-box" :href="item.jump_url" target="_blank" v-for="(item,index) in link_list"
                       :key="index">
                        <img :src="item.img_url" alt="">
                    </a>
                </div>
            </div>
        </div>
        <div class="views-footer-shell">
            <div class="views-footer-content">
                <div class="footer-nav-list">
                    <router-link class="nav-box" to="/">首页</router-link>
                    <div class="box-line"></div>
                    <router-link class="nav-box" to="/classify">课程分类</router-link>
                    <div class="box-line"></div>
                    <router-link class="nav-box" to="/journalism">行业资讯</router-link>
                    <div class="box-line"></div>
                    <router-link class="nav-box" to="/AboutUs">关于我们</router-link>
                </div>
                <div class="footer-info-shell">
                    <div class="info-left">
                        <div>备案号:湘ICP备18002586号-1</div>
                        <div>CopyrightⒸ2020长沙市湘源医药食品职业培训学校版权所有</div>
                        <div>
                            客服电话:400-811-5865转1
                        </div>
                        <div>
                            地址:长沙市芙蓉区湖南隆平科技园东湖湖南生机电职院东湖校区培训楼A栋
                        </div>
                    </div>
                    <div class="info-right">
                        <div class="code">
                            <div class="qrcode-title">扫码手机学习</div>
                            <img class="img" src="@/assets/gzhxx.png" alt=""/>
                        </div>
                        <div class="code">
                            <div class="qrcode-title">专属老师微信</div>
                            <img class="img" src="@/assets/zslswx.png" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="server-shell">
            <div class="server-box server-box1">
                <img src="@/assets/server-icon.png" alt="点击复制客服电话">
                <div class="server-phone-shell ">
                    <div class="tips">客服电话</div>
                    <div class="phone">400-811-5865转1</div>
                </div>
            </div>
            <div class="server-box server-box2">
                <img src="@/assets/wechat-icon.png" alt="">
                <div class="server-wechat-shell">
                    <div class="tips">在线客服</div>
                    <img src="@/assets/server-wechat13.png" alt="">
                </div>
            </div>
            <div class="server-box server-box2">
                <img src="@/assets/phone-icon.png" alt="">
                <div class="server-wechat-shell">
                    <div class="tips">手机学习</div>
                    <img src="@/assets/xcx.jpg" alt="">
                    <span>关注公众号>药师培训>下载APP学习</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        link_list: []
      }
    },
    mounted () {
      this.get_firend_link()
    },
    methods: {
      cut_nav (index) {
      },
      get_firend_link () {
        this.API.post('Home/article_out-get_links', {}).then((res) => {
          this.link_list = res.data.link_list
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .views-footer-shell {
        width: 100%;
        min-height: 358px;
        background: #18949c;
        padding-bottom: 50px;


        .footer-nav-list {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 57px 0;

            .nav-box {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
            }
        }

        .box-line {
            width: 1px;
            height: 18px;
            background: #D9D9D9;
            margin: 0 65px;
        }

        .footer-info-shell {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .info-left {
                > div {
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    margin-bottom: 20px;
                }

                .server-phone {
                    font-size: 18px;
                }

                .phone {
                    font-size: 20px;
                    font-weight: bold;
                    margin-top: 10px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #fff;
                }
            }

            .info-right {
                display: flex;
                flex-wrap: wrap;

                .qrcode-title {
                    margin-bottom: 10px;
                    color: #fff;
                    font-size: 20px;
                    border-bottom: 1px solid #dcdee0;
                    padding-bottom: 10px;
                }

                .code {
                    margin-right: 30px;
                }
            }
        }

        .code {
            width: 150px;
            height: 167px;
        }

    }

    .views-footer-content {
        width: 1200px;
        margin: 0 auto;
    }

    .friend-link-shell {
        background-color: #fff;
        border-bottom: 1px solid #eee;

        .friend-link-title {
            display: flex;
            align-items: center;
            height: 60px;
            font-size: 24px;
            color: #333;
        }

        .friend-link-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .friend-link-box {
                display: flex;
                align-items: center;
                width: 25%;
                font-size: 20px;
                color: #fff;
                min-height: 60px;

                img {
                   padding: 10px;
                }
            }
        }
    }

    .server-shell {
        position: fixed;
        right: 2%;
        bottom: 8%;
        z-index: 9;

        .server-box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 120px;
            height: 120px;
            background-color: #2aa9b5;
            margin-bottom: 20px;
            border-radius: 8px;
            z-index: 9;
            cursor: pointer;

            img {
                width: 60px;
                height: 60px;
            }

            .server-phone-shell, .server-wechat-shell {
                display: none;
            }
        }

        .server-box1:hover {
            .server-phone-shell {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;
                position: absolute;
                left: 0px;
                transform: translateX(-202px);
                width: 200px;
                height: 120px;
                border-radius: 8px;
                background-color: #2aa9b5;
                color: #fff;
                padding: 0 10px;

                .tips {
                    display: flex;
                    align-items: center;
                    height: 40px;
                    width: 100%;
                    color: #fff;
                    padding: 0 30px;
                    border-bottom: 1px solid #fff;
                }

                .phone {
                    font-size: 24px;
                    font-weight: 600;
                }
            }
        }

        .server-box2:hover {
            .server-wechat-shell {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                position: absolute;
                left: 0px;
                padding: 0 10px;
                transform: translateX(-303px);
                width: 300px;
                height: 300px;
                border-radius: 8px;
                background-color: #2aa9b5;
                color: #fff;

                .tips {
                    display: flex;
                    align-items: center;
                    height: 50px;
                    width: 100%;
                    color: #fff;
                    padding: 0 30px;
                    border-bottom: 1px solid #fff;
                }

                img {
                    width: 200px;
                    height: 200px;
                }
            }
        }
    }
</style>
